import { map, tap } from 'rxjs';
import { AppRoutes } from 'src/app/app.routes';

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrganisationUserAccessLevel } from '@organisations/models/organisation-user';
import { OrganisationSelectedService } from '@organisations/services/organisation-selected/organisation-selected.service';

export const accessLevelGuard: CanActivateFn = () => {
	const organisationSelected = inject(OrganisationSelectedService);
	const router = inject(Router);

	return organisationSelected.selectedOrganisation.pipe(
		map((organisation) => {
			const access = organisation?.organisationUser.accessLevel;
			return access !== undefined && [OrganisationUserAccessLevel.OWNER, OrganisationUserAccessLevel.ADMIN].includes(access);
		}),
		tap((hasAccess) => {
			if (!hasAccess) {
				router.navigate([AppRoutes.DASHBOARD]);
			}
		}),
	);
};
